import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f5f02de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admincontainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "button",
      tag: "li",
      to: { name: 'AdminAbteilungen' }
    }, {
      default: _withCtx(() => [
        _createTextVNode("Abteilungen")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "button",
      tag: "li",
      to: { name: 'AdminBenutzer' }
    }, {
      default: _withCtx(() => [
        _createTextVNode("Benutzer:innen")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "button",
      tag: "li",
      to: { name: 'AdminFeedback' }
    }, {
      default: _withCtx(() => [
        _createTextVNode("Einschätzungen")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "button",
      tag: "li",
      to: { name: 'AdminSkills' }
    }, {
      default: _withCtx(() => [
        _createTextVNode("Skills")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      class: "button",
      tag: "li",
      to: { name: 'AdminUmfragen' }
    }, {
      default: _withCtx(() => [
        _createTextVNode("Umfragen")
      ]),
      _: 1
    })
  ]))
}